const demoSiteConfig = {
  isDemo: false, // "true" for Load demo data or "false" for live site api call
};
export default demoSiteConfig;
